// extracted by mini-css-extract-plugin
module.exports =  {"styledModal":"PanesLimitModal-module__styledModal--gCdmH","text":"PanesLimitModal-module__text--Z3WZQ"};